<div class="d-flex justify-content-end" style="border-bottom: 2px solid #b4adad;">
    <button class="btn blue-btn btn-sm mb-1 mr-4" (click)="isDownloadPDF=true;PDFDownload();">Download</button>
    <button class="btn blue-btn btn-sm mb-1 mr-2" (click)="PrintLetter()">
        Print
      </button>
</div>

<kendo-pdf-export #pdfUAC_Letter paperSize="A4" margin="0.8cm">
<div class="uacsheet mt-1" id="uacLetter">
        <div class="title">
        <h3 class="font-weight-bold">Uniform COVER SHEET</h3>
        <h3 class="font-weight-bold">For Health Care Claim Attachments</h3>
        <span class="title-note">NOTE: To maximize use of this form, use of Microsoft Word version
            2003 or later is recommended</span>
        </div>
    <div class="notes">
        <p>Select appropriate payer/group purchaser from the drop-down list or fill-in the “Other” option</p>
    </div>
    
    <div class="d-flex mt-4">
        <div class="col-2 p-0 mt-1"> 
            <h4 class="font-weight-bold">TO :</h4>
        </div>
        <div class="lables col-12 p-0">
            <div class="purchaser-option">
                <label class="label-name col-3 px-0">Select fax # :</label>
                <select class="sheet-input col-5" [(ngModel)]="faxName" id="Group">
                        <option [value]="fl.value" *ngFor="let fl of UACFaxList">
                            {{fl.lovCode }}
                        </option>
                </select>
            </div>
            <div class="purchaser-option">
                <label class="label-name col-3 px-0">Other fax # :</label>
                <input class="sheet-input col-5" [(ngModel)]="otherFax">
            </div>
            <div class="purchaser-option">
                <label class="label-name col-3 px-0">Name :</label>
                <input class="sheet-input col-5" [(ngModel)]="global.coverLetterDetails.name">
            </div>
            <div class="purchaser-option">
                <label class="label-name col-3 px-0">Fax # :</label>
                <input class="sheet-input col-5" [(ngModel)]="faxName">
            </div>
        </div>
    </div>
    <div class="tosheet-feilds">
        <div class="lables">
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Attachment Control Number :</label>
                <input class="sheet-input col-5" [(ngModel)]="global.coverLetterDetails.attachmentControlNumber">
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Billing Provider ID # :</label>
                <input class="sheet-input col-5" [(ngModel)]="global.coverLetterDetails.billingProviderId">
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Billing Provider Name :</label>
                <input class="sheet-input col-5" [(ngModel)]="global.coverLetterDetails.billingProviderName">
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Patient ID # :</label>
                <input class="sheet-input col-5" [(ngModel)]="global.coverLetterDetails.patientId">
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Patient Name :</label>
                <div class="d-flex col-5 px-0">
                    <input class="multipleinput col-4" placeholder="Last Name" [(ngModel)]="global.coverLetterDetails.patient_LastName">
                    <input class="multipleinput col-4" placeholder="First Name" [(ngModel)]="global.coverLetterDetails.patient_FirstName">
                    <input class="multipleinput col-4" placeholder="Middle Name" [(ngModel)]="global.coverLetterDetails.patient_MiddleName">
                </div>
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Property and Casualty Claim # :</label>
                <input class="sheet-input col-5" [(ngModel)]="PropertyandCasualtyClaim">
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Attachment Send Date :</label>
                <input class="sheet-input col-5" [(ngModel)]="global.coverLetterDetails.attachmentSendDate">
            </div>
            <div class="purchaser-option">
                <label class="col-5 px-0 my-auto">Contact Name/Phone # :</label>
                <input class="sheet-input col-5" [(ngModel)]="ContactNamePhone" >
            </div>
        </div>

    </div>
    <div class="mt-3">
        <div class="purchaser-option ml-1">
            <label class="label-name col-5 px-0 my-auto">Disclaimer :</label>
            <input class="sheet-input col-5" [(ngModel)]="Disclaimer">
        </div>
    </div>
    </div>
</kendo-pdf-export>


